import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import * as moment from 'moment/moment';

@Component({
	selector: 'app-time-field',
	templateUrl: './time-field.component.html',
	styleUrls: ['./time-field.component.scss'],
})
export class TimeFieldComponent implements OnInit {
	@Input() inputName: string;
	@Input() form: UntypedFormGroup;
	@Input() label: string;
	@Input() isError: boolean;
	@Input() placeholder: string;
	@Input() uniqueId: string;
	@Input() preValue: string;

	timePeriod: string;
	lastSelectedValue: any;
	defaultDate: string;
	isPickerOpen = false;

	constructor() {}

	ngOnInit() {
		if (this.preValue) {
			const isoPrevalue = this.convertTimeToISO(this.preValue);
			this.defaultDate = isoPrevalue;
			this.form.get(this.inputName)?.setValue(isoPrevalue);
			this.lastSelectedValue = isoPrevalue;
		}
	}

	get displayValue(): string {
		const val = this.form.get(this.inputName)?.value;
		if (!val) return '';
		const d = new Date(val);
		return isNaN(d.getTime()) ? '' : d.toLocaleTimeString('en-GB', {hour: '2-digit', minute: '2-digit'});
	}

	openPicker() {
		this.lastSelectedValue = this.form.get(this.inputName)?.value;
		this.isPickerOpen = true;
	}

	onModalDismiss() {
		this.isPickerOpen = false;
	}

	convertTimeToISO(timeString: string): string {
		try {
			const [time, period] = timeString.toLowerCase().split(/(am|pm)/);
			let [hours, minutes] = time.split(':').map(Number);

			if (period === 'pm' && hours !== 12) {
				hours += 12;
			} else if (period === 'am' && hours === 12) {
				hours = 0;
			}

			const currentDate = new Date();
			const year = currentDate.getUTCFullYear();
			const month = currentDate.getUTCMonth();
			const day = currentDate.getUTCDate();
			const dateTime = new Date(Date.UTC(year, month, day, hours, minutes));

			dateTime.setUTCHours(hours, minutes, 0, 0);

			const startOfBST = new Date(Date.UTC(year, 2, -((new Date(year, 2, 31).getDay() + 1) % 7), 1));
			const endOfBST = new Date(Date.UTC(year, 9, -((new Date(year, 9, 31).getDay() + 1) % 7), 1));

			if (dateTime >= startOfBST && dateTime < endOfBST) {
				dateTime.setTime(dateTime.getTime() + 60 * 60 * 1000);
			}
			return dateTime.toISOString();
		} catch {
			const date = new Date(`January 1, 1970 00:00:00`);
			return date.toISOString();
		}
	}

	timePeriodChange(period) {
		const control = this.form.controls[this.inputName];
		const dateTime = moment(control.value);
		const currentPeriod = dateTime.format('a');

		if (period.toLowerCase() !== currentPeriod.toLowerCase()) {
			if (period.toLowerCase() === 'am') {
				dateTime.subtract(12, 'hours');
			} else if (period.toLowerCase() === 'pm') {
				dateTime.add(12, 'hours');
			}
		}
		control.setValue(dateTime.toISOString());
		this.timePeriod = period;
	}

	onCancelClick() {
		this.form.get(this.inputName).setValue(this.lastSelectedValue);
		this.isPickerOpen = false;
	}

	async onConfirmClick() {
		const selectedDateTime = this.form.get(this.inputName).value;
		if (!selectedDateTime && this.inputName) {
			const currentDate = new Date();
			const year = currentDate.getFullYear();
			const month = currentDate.getMonth() + 1;
			const day = currentDate.getDate();
			const hours = currentDate.getHours();
			const minutes = currentDate.getMinutes();
			const seconds = currentDate.getSeconds();
			const isoString = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}T${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
			this.form.get(this.inputName).setValue(isoString);
		}
		this.lastSelectedValue = this.form.get(this.inputName).value;
		this.isPickerOpen = false;
	}
}
